import React from 'react';

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import OutlinedButton from 'components/application/buttons/OutlinedButton';

import CardWrapper from './CardWrapper';

export default function SelectedCard({
  folderName,
  onEdit,
  onUnlink,
  projectName,
}) {
  const { t: i18nTShared } = useTranslation('common', {
    keyPrefix: 'shared',
  });

  return (
    <CardWrapper>
      <div className='tw-font-semibold tw-text-grey-900'>{projectName}</div>
      <div>{folderName}</div>
      <div className='tw-mt-3 tw-flex'>
        <OutlinedButton
          className='tw-mr-4'
          color='grey'
          onClick={onEdit}
          size='sm'
        >
          {i18nTShared('edit')}
        </OutlinedButton>
        <OutlinedButton color='red' onClick={onUnlink} size='sm'>
          {i18nTShared('unlink')}
        </OutlinedButton>
      </div>
    </CardWrapper>
  );
}

SelectedCard.propTypes = {
  folderName: PropTypes.string.isRequired,
  onEdit: PropTypes.func.isRequired,
  onUnlink: PropTypes.func.isRequired,
  projectName: PropTypes.string.isRequired,
};
